import { Study } from './studies';

export enum OrganizationResearcherRole {
  ADMIN = 'admin',
  RESEARCHER = 'researcher',
}

export interface OrganizationDto {
  organization: Organization;
  studies: Study[];
  researchers: OrganizationResearcher[];
  admins: OrganizationResearcher[];
  dataSources: OrganizationDataSource[];
  organizationalUnits: Organization[];
}

export interface Organization {
  rootOrganizationId: string;
  organizationId: string;
  name: string;
  displayName: string;

  numDataSources: number;
  numResearchers: number;
  numStudies: number;

  orgWideAccess: boolean;

  createdAt: string;
  updatedAt: string;
}

export interface OrganizationResearcher {
  rootOrganizationId: string;
  organizationId: string;
  researcherId: string;
  userId: string;

  organizationName: string;
  organizationDisplayName: string;

  researcherFamilyName: string;
  researcherGivenName: string;
  researcherEmail: string;
  isAdmin: boolean;

  createdAt: string;
  updatedAt: string;

  entity: string;
}

export interface OrganizationStudy {
  rootOrganizationId: string;
  organizationId: string;
  organizationName: string;
  organizationDisplayName: string;
  studyId: string;
  studyName: string;
  studyDisplayName: string;

  createdAt: string;
  updatedAt: string;
}

export interface OrganizationDataSource {
  rootOrganizationId: string;
  organizationId: string;
  organizationName: string;
  organizationDisplayName: string;

  dataSourceId: string;
  dataSourceName: string;
  dataSourceDisplayName: string;

  createdAt: string;
  updatedAt: string;
}

export interface OrganizationResearchersQueryDto {
  researchers: OrganizationResearcher[];
}

export interface OrganizationDatasourcesQueryDto {
  dataSources: OrganizationDataSource[];
}
